import { render, staticRenderFns } from "./Site.vue?vue&type=template&id=1945a30a&scoped=true&"
import script from "./Site.vue?vue&type=script&lang=js&"
export * from "./Site.vue?vue&type=script&lang=js&"
import style0 from "./Site.vue?vue&type=style&index=0&id=1945a30a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945a30a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/aikl_dev/Projects/v2/kcc/aikl_v2_front_kcc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1945a30a')) {
      api.createRecord('1945a30a', component.options)
    } else {
      api.reload('1945a30a', component.options)
    }
    module.hot.accept("./Site.vue?vue&type=template&id=1945a30a&scoped=true&", function () {
      api.rerender('1945a30a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/Site.vue"
export default component.exports